export const AUTH_SET_REDIRECT_PATH = 'AUTH_SET_REDIRECT_PATH'
export const AUTH_SET_TOKEN = 'AUTH_SET_TOKEN'
export const AUTH_REQUEST = 'AUTH_REQUEST'
export const AUTH_SET_STAFF_ACCESS_TOKEN = 'AUTH_SET_STAFF_ACCESS_TOKEN'
export const AUTH_AUTO_REQUEST = 'AUTH_AUTO_REQUEST'
export const AUTH_REGISTER = 'AUTH_REGISTER'
export const AUTH_LOGOUT = 'AUTH_LOGOUT'
export const AUTH_FORGOT = 'AUTH_FORGOT'
export const AUTH_RESET = 'AUTH_RESET'
export const AUTH_SET_TEAM_MEMBERS = 'AUTH_SET_TEAM_MEMBERS'
export const AUTH_FORCE_2FA_SETUP = 'AUTH_FORCE_2FA_SETUP'
export const AUTH_SUCCESS = 'AUTH_SUCCESS'
export const AUTH_ON_SUCCESS_RESPONSE = 'AUTH_ON_SUCCESS_RESPONSE'
export const AUTH_SET_ACTIVE_TEAM = 'AUTH_SET_ACTIVE_TEAM'
export const AUTH_REFRESH_DATA = 'AUTH_REFRESH_DATA'
export const TEAM_CREATE = 'TEAM_CREATE'
export const AUTH_ACCESS_TEAM_WITH_CALLBACK_URL = 'AUTH_ACCESS_TEAM_WITH_CALLBACK_URL'
export const AUTH_USER_PERMISSIONS_GET = 'AUTH_USER_PERMISSIONS_GET'
export const AUTH_USER_PERMISSIONS_SET = 'AUTH_USER_PERMISSIONS_SET'
export const AUTH_USER_TEAM_ROLES_SET = 'AUTH_USER_TEAM_ROLES_SET'
export const AUTH_USER_IS_STAFF_SET = 'AUTH_USER_IS_STAFF_SET'

export const MEMBERS_PRESENCE_SET = 'MEMBERS_PRESENCE_SET'

export const ONBOARD_WELCOME_COMPLETE = 'ONBOARD_WELCOME_COMPLETE'
export const SET_ONBOARD = 'SET_ONBOARD'
export const SET_ONBOARD_STEPS = 'SET_ONBOARD_STEPS'
export const ONBOARDING_REFRESH = 'ONBOARDING_REFRESH'

export const SELECT_ACTIVE_TEAM_MODAL = 'SELECT_ACTIVE_TEAM_MODAL'

export const USER_UPDATE = 'USER_UPDATE'
export const TEAM_UPDATE = 'TEAM_UPDATE'
export const TEAM_UPDATE_PROP = 'TEAM_UPDATE_PROP'

export const APP_DATA_FETCH = 'APP_DATA_FETCH'

export const AVATARS_FETCH = 'AVATARS_FETCH'
export const AVATARS_SET = 'AVATARS_SET'

export const USER_FETCH_LIST = 'USER_FETCH_LIST'
export const TEAMS_STATS_FETCH = 'TEAMS_STATS_FETCH'
export const TEAMS_STATS_SET = 'TEAMS_STATS_SET'

export const AUTOMATION_APPS_FETCH = 'AUTOMATION_APPS_FETCH'
export const AUTOMATION_APPS_SET = 'AUTOMATION_APPS_SET'
